import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';

export default function Footer() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/gemiya-logo.png" alt="Gemiya" className="footer-logo-img" />
          <p>{t('footer.desc')}</p>
          <div className="footer-social">
            <button className="social-btn">🌐</button>
            <button className="social-btn">📷</button>
          </div>
        </div>
        <div className="footer-col">
          <h3>{t('footer.links')}</h3>
          <ul className="footer-links-list">
            <li><button className="footer-nav-btn" onClick={() => navigate("/")}>{t("footer.home")}</button></li>
            <li><button className="footer-nav-btn" onClick={() => navigate("/menu")}>{t("nav.menu")}</button></li>
            <li><button className="footer-nav-btn" onClick={() => navigate("/reservations")}>{t("nav.reserve")}</button></li>
            <li><a href="tel:+33788313074">{t('footer.catering')}</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h3>{t('footer.contact')}</h3>
          <div className="footer-contact-row">📞 <a href="tel:+33788313074">+33 7 88 31 30 74</a></div>
          <div className="footer-contact-row">📧 bonjour@gemiya.fr</div>
          <div className="footer-contact-row" style={{marginTop:'.5rem'}}>🕐 11h30 – 22h30</div>
        </div>
        <div className="footer-col">
          <h3>{t('footer.newsletter')}</h3>
          <p style={{fontSize:'.84rem',color:'rgba(255,255,255,.5)',marginBottom:'.7rem'}}>{t('footer.newsletter.desc')}</p>
          <div className="newsletter-form">
            <input className="newsletter-input" type="email" placeholder="Email" />
            <button className="newsletter-btn">OK</button>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © 2025 Gemiya Restaurant. Tous droits réservés.
        <span style={{margin:'0 .6rem', opacity:.4}}>·</span>
        Crafted with ♥ by Calico Tech Labs
      </div>
    </footer>
  );
}
